import { render } from "./BoardControl.vue?vue&type=template&id=adf0a356"
import script from "./BoardControl.vue?vue&type=script&lang=js"
export * from "./BoardControl.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__